import React from 'react';
import { Row, Col, Label } from "reactstrap";

export default class ContainersDetalhesMovimentacoes extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="containers-detalhes">
                <h2>
                    Movimentações
                    <span className={this.props.dadosContainer.Situacao && "situacao-btn fora-terminal"}>
                        {this.props.dadosContainer.Situacao}
                    </span>
                </h2>
                <Row>
                    <Col xs={6} sm={4} className="containers-detalhes-col">
                        <Row>
                            <Col>
                                <Label className="label-disabled">CATEGORIA</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Label className="label-secondary">{this.props.dadosContainer.Subcategoria && this.props.dadosContainer.Subcategoria.toUpperCase() === 'CABOTAGEM' ? this.props.dadosContainer.Subcategoria.toUpperCase() : this.props.dadosContainer.Categoria ? this.props.dadosContainer.Categoria : "---"}</Label>
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={6} sm={4} className="containers-detalhes-col">
                        <Row>
                            <Col>
                                <Label className="label-disabled">PORTO DESCARGA</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Label className="label-secondary">{this.props.dadosContainer.PortoDescarga ? this.props.dadosContainer.PortoDescarga : "---"}</Label>
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={6} sm={4} className="containers-detalhes-col">
                        <Row>
                            <Col>
                                <Label className="label-disabled">PORTO DE CARGA</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Label className="label-secondary">{this.props.dadosContainer.PortoCarga ? this.props.dadosContainer.PortoCarga : "---"}</Label>
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={6} sm={4} className="containers-detalhes-col">
                        <Row>
                            <Col>
                                <Label className="label-disabled">ENTRADA</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Label className="label-secondary">{this.props.dadosContainer.EntradaDetalhe ? this.props.dadosContainer.EntradaDetalhe : "---"} | {this.props.dadosContainer.EntradaData ? this.props.dadosContainer.EntradaData : "---"}</Label>
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={6} sm={4} className="containers-detalhes-col">
                        <Row>
                            <Col>
                                <Label className="label-disabled">SAÍDA</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Label className="label-secondary">{this.props.dadosContainer.SaidaDetalhe ? this.props.dadosContainer.SaidaDetalhe : "---"} | {this.props.dadosContainer.SaidaData ? this.props.dadosContainer.SaidaData : "---"}</Label>
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={6} sm={4} className="containers-detalhes-col">
                        <Row>
                            <Col>
                                <Label className="label-disabled">CLIENTE</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Label className="label-secondary">{this.props.dadosContainer.Cliente ? this.props.dadosContainer.Cliente : "---"}</Label>
                            </Col>
                        </Row>
                    </Col>
                    {!process.env.rig &&
                        <Col xs={6} sm={4} className="containers-detalhes-col">
                            <Row>
                                <Col>
                                    <Label className="label-disabled">DESPACHANTE</Label>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Label className="label-secondary">{this.props.dadosContainer.Despachante ? this.props.dadosContainer.Despachante : "---"}</Label>
                                </Col>
                            </Row>
                        </Col>}
                    <Col xs={6} sm={4} className="containers-detalhes-col">
                        <Row>
                            <Col>
                                <Label className="label-disabled">DIAS NO PÁTIO</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Label className="label-secondary">{this.props.dadosContainer.DiasPatio ? this.props.dadosContainer.DiasPatio : "---"}</Label>
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={6} sm={4} className="containers-detalhes-col">
                        <Row>
                            <Col>
                                <Label className="label-disabled">MERCADORIA</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Label className="label-secondary">{this.props.dadosContainer.MercadoriaNcm ? this.props.dadosContainer.MercadoriaNcm + " - " + this.props.dadosContainer.MercadoriaDesc : "---"}</Label>
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={6} sm={4} className="containers-detalhes-col">
                        <Row>
                            <Col>
                                <Label className="label-disabled">CARGA REFRIGERADA</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Label className="label-secondary">{
                                (this.props.dadosContainer.TempRefri || this.props.dadosContainer.TempRefri===0) 
                                ? "SIM" : "NÃO"}</Label>
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={6} sm={4} className="containers-detalhes-col">
                        <Row>
                            <Col>
                                <Label className="label-disabled">CARGA PERIGOSA</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Label className="label-secondary">{this.props.dadosContainer.IndPerigosa && this.props.dadosContainer.IndPerigosa.toUpperCase() === "SIM" ? "SIM" : "NÃO"}</Label>
                            </Col>
                        </Row>
                    </Col>
                    {this.props.dadosContainer.Categoria === "IMPORTAÇÃO" ?
                        <Col xs={6} sm={4} className="containers-detalhes-col">
                            <Row>
                                <Col>
                                    <Label className="label-disabled">BL MASTER</Label>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Label className="label-secondary">{this.props.dadosContainer.BlMaster ? this.props.dadosContainer.BlMaster : "---"}</Label>
                                </Col>
                            </Row>
                        </Col>
                        : null}
                    {!process.env.rig &&
                        <Col xs={6} sm={4} className="containers-detalhes-col">
                            <Row>
                                <Col>
                                    <Label className="label-disabled">PESO BRUTO</Label>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Label className="label-secondary">{this.props.dadosContainer.PesoBruto ? this.props.dadosContainer.PesoBruto : "---"}</Label>
                                </Col>
                            </Row>
                        </Col>}
                    {this.props.dadosContainer.Status === "CHEIO" &&
                        <Col xs={6} sm={4} className="containers-detalhes-col">
                            <Row>
                                <Col>
                                    <Label className="label-disabled">PESO DOCUMENTAL</Label>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Label className="label-secondary">{this.props.dadosContainer.PesoDocum ? this.props.dadosContainer.PesoDocum : "---"}</Label>
                                </Col>
                            </Row>
                        </Col>
                    }
                    {process.env.rig && this.props.dadosContainer.Categoria !== "TRANSBORDO" && this.props.dadosContainer.Status === "CHEIO" &&
                        <Col xs={6} sm={4} className="containers-detalhes-col">
                            <Row>
                                <Col>
                                    <Label className="label-disabled">PESO AFERIDO</Label>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Label className="label-secondary">{this.props.dadosContainer.PesoAferido ? this.props.dadosContainer.PesoAferido : "---"}</Label>
                                </Col>
                            </Row>
                        </Col>}
                </Row>
                <Row>
                    {this.props.dadosContainer.Categoria !== "IMPORTAÇÃO"
                        ? <Col xs={6} sm={4} className="containers-detalhes-col-status">
                            <Row>
                                <Col>
                                    <Label className="label-disabled">TECON</Label>
                                    {this.props.dadosContainer.StatusTecon === "RETIDO" && <span className="situacao-btn cancelado"> {this.props.dadosContainer.StatusTecon} </span>}
                                    {this.props.dadosContainer.StatusTecon === "LIBERADO" && <span className="situacao-btn ok"> {this.props.dadosContainer.StatusTecon} </span>}
                                </Col>
                            </Row>
                        </Col>
                        : null}
                    {this.props.dadosContainer.Categoria !== "IMPORTAÇÃO"
                        ? <Col xs={6} sm={4} className="containers-detalhes-col-status">
                            <Row>
                                <Col>
                                    <Label className="label-disabled">{process.env.rig ? 'SRF' : 'SISCOMEX'}</Label>
                                    {this.props.dadosContainer.StatusSiscomex === "RETIDO" && <span className="situacao-btn cancelado"> {this.props.dadosContainer.StatusSiscomex} </span>}
                                    {this.props.dadosContainer.StatusSiscomex === "LIBERADO" && <span className="situacao-btn ok"> {this.props.dadosContainer.StatusSiscomex} </span>}
                                </Col>
                            </Row>
                        </Col>
                        : null}
                    {this.props.dadosContainer.Categoria !== "IMPORTAÇÃO"
                        ? <Col xs={6} sm={4} className="containers-detalhes-col-status">
                            <Row>
                                <Col>
                                    <Label className="label-disabled">SISCARGA</Label>
                                    {this.props.dadosContainer.StatusSiscarga === "RETIDO" && <span className="situacao-btn cancelado"> {this.props.dadosContainer.StatusSiscarga} </span>}
                                    {this.props.dadosContainer.StatusSiscarga === "LIBERADO" && <span className="situacao-btn ok"> {this.props.dadosContainer.StatusSiscarga} </span>}
                                </Col>
                            </Row>
                        </Col>
                        : null}
                </Row>
                {process.env.rig &&
                    <Row>
                        <Col xs={12} sm={12} className="containers-detalhes-col">
                            <br />
                            <Label>Sobremedidas</Label>
                        </Col>
                        <Col xs={6} sm={4} className="containers-detalhes-col">
                            <Row>
                                <Col>
                                    <Label className="label-disabled">ALTURA</Label>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Label className="label-secondary">{this.props.dadosContainer.SobremedidaTop ? this.props.dadosContainer.SobremedidaTop : "---"}</Label>
                                </Col>
                            </Row>
                        </Col>
                        <Col xs={6} sm={4} className="containers-detalhes-col">
                            <Row>
                                <Col>
                                    <Label className="label-disabled">DIREITA</Label>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Label className="label-secondary">{this.props.dadosContainer.SobremedidaDir ? this.props.dadosContainer.SobremedidaDir : "---"}</Label>
                                </Col>
                            </Row>
                        </Col>
                        <Col xs={6} sm={4} className="containers-detalhes-col">
                            <Row>
                                <Col>
                                    <Label className="label-disabled">ESQUERDA</Label>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Label className="label-secondary">{this.props.dadosContainer.SobremedidaEsq ? this.props.dadosContainer.SobremedidaEsq : "---"}</Label>
                                </Col>
                            </Row>
                        </Col>
                        <Col xs={6} sm={4} className="containers-detalhes-col">
                            <Row>
                                <Col>
                                    <Label className="label-disabled">FRENTE</Label>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Label className="label-secondary">{this.props.dadosContainer.SobremedidaFre ? this.props.dadosContainer.SobremedidaFre : "---"}</Label>
                                </Col>
                            </Row>
                        </Col>
                        <Col xs={6} sm={4} className="containers-detalhes-col">
                            <Row>
                                <Col>
                                    <Label className="label-disabled">TRASEIRA</Label>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Label className="label-secondary">{this.props.dadosContainer.SobremedidaTra ? this.props.dadosContainer.SobremedidaTra : "---"}</Label>
                                </Col>
                            </Row>
                        </Col>
                    </Row>}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/modules/consultas/containers/components/ContainersDetalhesMovimentacoes.js